import * as angular from 'angular';

"use strict";
angular.module('Module1UserManagementCtrl', []);

export default 'Module1UserManagementCtrl'
